export const lang = {
  swap1: '輸出為估值，您將獲得至少{inputOutMin} {symbol},或者交易將被撤',
  swap2: '輸入為估值，您將出售最多{inputInMax} {symbol},或者交易將被撤回',
  swap3: '輸出為估值。如果價格變化超過 {slippage}%，則您的交易將被撤回',
  swap4: '輸出為估值。如果價格變化超過 {slippage}%，則您的交易將被撤回',
  swap5: '確認交換',
  swap6: '正在等待確認',
  swap7: '正在將',
  swap8: '交換為',
  swap9: '在你的錢包種確認此交易',
  swap10: '已提交交易',
  swap11: '在BscScan上查看',
  swap12: '將Swan-LP添加到Metamsak',
  swap13: '交易拒絕',
  swap14: '關閉',
  swap15: '正在移除',
  swap16: '和',
  swap17: '正在供應',
  swap18: '兌換',
  swap19: '流動性',
  swap20: '從',
  swap21: '估計',
  swap22: '餘額',
  swap23: '最大',
  swap24: '選擇通證',
  swap25: '到',
  swap26: '連接錢包',
  swap27: '此交易的流動性不足',
  swap28: '輸入數量',
  swap29: '餘額不足',
  swap30: '選擇代幣',
  swap31: '授權',
  swap32: '包裝',
  swap33: '解包',
  swap34: '價格影響過高',
  swap35: '閃兌',
  swap36: '價格',
  swap37: '滑點容差',
  swap38: '價格影響',
  swap39: '路由',
  swap40: '最小獲得量',
  swap41: '流動性供應商費用',
  swap42: '交易收據',
  swap43: '閃對',
  swap44: '您將獲得',
  swap45: '最大出售量',
  swap46: '此交換的價格影響至少為 10%,請確認此交換',
  swap47: '確認',
  swap48: '取消',
  swap49: '最近交易',
  swap50: '全部清除',
  swap51: '最近沒有交易',
  swap52: '您的流動性',
  swap53: '已入池',
  swap54: '添加',
  swap55: '移除',
  swap56: '增加流動性',
  swap57: '沒有看到您加入的池？ ',
  swap58: '導入它',
  swap59: '如果您將XXX代幣質押在農場中，請在此處取消質押以查看它們',
  swap60: '您是第一個流動性供應商。 ',
  swap61: '您添加代幣的比列，將決定該流動性池的初始價格。 ',
  swap62: '如果您對匯率滿意，請點擊“供應”以進行檢查。 ',
  swap63: '輸入',
  swap64: '兌換率和流動池份額',
  swap65: '流動性池中的份額',
  swap66: '供應',
  swap67: '接收',
  swap68: '金額',
  swap69: '你將獲得',
  swap70: '您的錢包中的LP代幣',
  swap71: '移除流動性以收回代幣',
  swap72: '導入池',
  swap73: '選擇代幣以查找您的流動性。 ',
  swap74: '您在該流動性池中還沒有提供流動性。 ',
  swap75: '已入金',
  swap76: '匯率',
  swap77: '確認供應',
  swap78: '已焚毀',
  swap79: '資產變更',
  swap80: '提幣賬單',
  swap81: '提幣數量',
  swap82: '手續費',
  swap83: '實際到賬',
  swap84: '已通過',
  swap85: '已駁回',
  swap86: '我要買',
  swap87: '我要賣',
  swap88: '訂單',
  swap89: '需求發布',
  swap90: '單價',
  swap91: '管理代幣',
  swap92: '導入代幣',
  swap93: '搜索名稱或粘貼地址',
  swap94: '導入',
  swap95: '管理Tokens',
  swap96: '自定義代幣',
  swap97: '首頁',
  swap98: '交易',
  swap99: '資訊',
  swap100: '社區',
  swap101: '我的',
  swap102: '未連接',
  swap103: '申請中',
  swap104: '進入',
  swap105: '行情',
  swap106: '幣種',
  swap107: '漲跌幅',
  swap108: '蝴蝶部落是⼀群有共同興趣、認知、價值觀的社區，聯合在一起互動、交流、合作、感染而產⽣的新的信任和價值連結平臺，由這種建⽴在社群之間的情感關聯、信任產生新的部落型社區。 區塊鏈時代的來臨讓社群發揮了難以想像的⼒量，通過社群和社群組織之間更有效率的連接和價值交換，形成一個⾼效率且高效益的全新運轉經濟體',
  swap109: '暫未開放',
  swap110: '蝴蝶社區',
  swap111: 'SER & SES 雙幣聯動 · 輪迴重生即將開啟權益認籌',
  swap112: '社區公告',
  swap113: '聯繫人',
  swap114: '消息',
  swap115: '圈子',
  swap116: '搜索聯繫人',
  swap117: '暫無聯繫人',
  swap118: '暫無數據',
  swap119: '屏蔽該用戶',
  swap120: '舉報該內容',
  swap121: '快轉',
  swap122: '引用',
  swap123: '分享',
  swap124: '新的朋友',
  swap125: '群組',
  swap126: '頻道',
  swap127: '附近的人和群',
  swap128: '發表',
  swap129: '請輸入發表內容',
  swap130: '只接受 JPG、BMP、PNG、GIF 格式',
  swap131: '上傳中...',
  swap132: '上傳成功',
  swap133: '上傳失敗',
  swap134: '請輸入內容',
  swap135: '請添加圖片',
  swap136: '表布成功',
  swap137: '深度',
  swap138: '快訊',
  swap139: '閃兌賬單',
  swap140: '當前餘額不足',
  swap141: '請選擇幣種',
  swap142: '兌換成功',
  swap143: '已賺取',
  swap144: '年化利率',
  swap145: '收割',
  swap146: '質押',
  swap147: '進行中',
  swap148: '已結束',
  swap149: '我參與的',
  swap150: '質押lp代幣',
  swap151: '贖回lp代幣',
  swap152: '贖回',
  swap153: '確實',
  swap154: '分享鏈接',
  swap155: '新手資料',
  swap156: '更多',
  swap157: '發圖素材',
  swap158: '常用工具',
  swap159: '常見問題',
  swap160: '市場機制',
  swap161: '發展規劃',
  swap162: '上一張',
  swap163: '下一張',
  swap164: '發圈素材',
  swap165: '發圈海報',
  swap166: '發圈視頻',
  swap167: '發圈文案',
  swap168: '市場活動',
  swap169: '節日祝福',
  swap170: '好友邀請',
  swap171: '項目介紹',
  swap172: '全部',
  swap173: '轉入',
  swap174: '轉出',
  swap175: '轉賬',
  swap176: '收款',
  swap177: '請輸入轉賬數量',
  swap178: '請輸入接收人地址',
  swap179: '轉賬成功',
  swap180: '接收人',
  swap181: '數量',
  swap182: '可轉',
  swap183: '請選擇',
  swap184: '請輸入數量',
  swap185: '最大轉賬',
  swap186: '最小轉賬',
  swap187: '交易值扣除',
  swap188: '手續費扣減',
  swap189: '請輸入要修改的暱稱',
  swap190: '保存',
  swap191: '請先上傳圖片',
  swap192: '修改成功',
  swap193: '我要反饋',
  swap194: '回复',
  swap195: '反饋標題',
  swap196: '標題',
  swap197: '請填寫標題',
  swap198: '反饋內容',
  swap199: '請填寫內容',
  swap200: '附件',
  swap201: '提交',
  swap202: '暫無回复',
  swap203: '提交成功',
  swap204: '您的問題',
  swap205: '您在使用app過程中遇見什麼問題，或者對平台有什麼建議都可以寫在這裡哦',
  swap206: '請填寫回复內容',
  swap207: '蝴蝶學院',
  swap208: '邀請好友',
  swap209: '星級中心',
  swap210: '資產',
  swap211: '可用',
  swap212: '凍結',
  swap213: '貢獻值',
  swap214: '查看礦池',
  swap215: '資產明細',
  swap216: '請先鏈接賬號',
  swap217: '去邀請',
  swap218: '我的推薦人',
  swap219: '暫無上級',
  swap220: '我的推薦',
  swap221: '暫無推薦',
  swap222: '複製成功',
  swap223: '不支持複製,該瀏覽器不支持自動複製',
  swap224: '劃轉',
  swap225: '持有礦池',
  swap226: '領取',
  swap227: '閱讀',
  swap228: '成長區',
  swap229: '贈送區',
  swap230: '首發中心',
  swap231: '蝴蝶部落是⼀群有共同興趣、認知、價值觀的社區，聯合在一起互動、交流、協作、感染而產⽣的新的信任和價值鏈接平台，由這種建⽴在社群之間的情感關聯、信任產生新的部落型社區。區塊鏈時代的來臨讓社群發揮了難以想像的⼒量，通過社群和社群組織之間更有效率的連接和價值交換，形成一個⾼效率且高效益的全新運轉經濟體。 ',
  swap232: '當前已完成進度百分比',
  swap233: '會超過100%',
  swap234: '總需捐獻',
  swap235: '您已捐獻',
  swap236: '說明',
  swap237: '本次xxxx領袖招募信息由xxxx提供並負責',
  swap238: '本次招募可超額進行，由xxxx社區進行考核，未予通過的領袖席位將自動退回捐獻資金、',
  swap239: '會員',
  swap240: '聯合合夥人',
  swap241: '股東合夥人',
  swap242: '恭喜您，您已獲得',
  swap243: '列表',
  swap244: '進行中',
  swap245: '已完成',
  swap246: '次數',
  swap247: '總產能',
  swap248: '號礦池',
  swap249: '號贈送',
  swap250: '總獎勵',
  swap251: '消耗',
  swap252: '完成次數',
  swap253: '已獎勵',
  swap254: '剩餘次數',
  swap255: '充值',
  swap256: '提現',
  swap257: '複製',
  swap258: '請輸入充值數量',
  swap259: '請輸入提現數量',
  swap260: '平台餘額',
  swap261: '充值成功',
  swap262: '轉賬失敗',
  swap263: '提現數量不可可用餘額',
  swap264: '當前不可提幣',
  swap265: '超過當前最大可提幣量',
  swap266: '提幣成功',
  swap267: '總資產',
  swap268: '代幣',
  swap269: '成交',
  swap270: '成交率',
  swap271: '限額',
  swap272: '去購買',
  swap273: '去出售',
  swap274: '請輸入購買數量',
  swap275: '購買數量須在限額內',
  swap276: '超過餘額',
  swap277: '購買成功',
  swap278: '出售成功',
  swap279: '我的訂單',
  swap280: '可用餘額',
  swap281: '請輸入出售數量',
  swap282: '剩餘可成交',
  swap283: '立即購買',
  swap284: '立即出售',
  swap285: '我的發布',
  swap286: '發布訂單',
  swap287: '發布類型',
  swap288: '購買',
  swap289: '出售',
  swap290: '支付方式',
  swap291: '請選擇支付方式',
  swap292: '請輸入單價',
  swap293: '發布數量',
  swap294: '請輸入發布數量',
  swap295: '選擇幣種',
  swap296: '最大限額',
  swap297: '請輸入最大限額',
  swap298: '最小限額',
  swap299: '請輸入最小限額',
  swap300: '發布',
  swap301: '輸入最大價格應為',
  swap302: '最小價格應為',
  swap303: '輸入最大數量應為',
  swap304: '最小數量應為',
  swap305: '買',
  swap306: '賣',
  swap307: '訂單號',
  swap308: '取消訂單',
  swap309: '撤銷成功',
  swap310: '單價不在範圍內',
  swap311: '數量不在範圍內',
  swap312: '請選擇發布幣種',
  swap313: '請選擇最小限額',
  swap314: '請選擇最大限額',
  swap315: '最小限額不得大於最大限額',
  swap316: '最大限額不能超過發布數量',
  swap317: '購買價格不能超過餘額',
  swap318: '發布數量不能超過餘額',
  swap319: '發布成功',
  swap320: '提幣',
  swap321: '你已加入',
  swap322: '加入',
  swap323: '請先登錄',
  swap324: '授權失敗',
  swap325: '加入成功',
  swap326: '實際兌換數量',
  swap327: '收到數量',
  swap328: '請輸入兌換數量',
  swap329: '請先添加邀請人',
  swap330: '升级',
  swap331: 'SER是DEFI領域基於DAO+ iGaming 3.0的生態型代幣，子幣SES。 通過全新的雙幣聯動的市場推動計畫，給予用戶娛樂性體驗的同時保障價值的持續穩定增長。 浴火涅盤、輪回重生、生生不息，價值不滅，SER權益認籌啟動中！',
  swap332: '我的獎勵',
  swap333: '推薦列表',
  swap334: '地址',
  swap335: '確定將',
  swap336: '劃轉到資產嗎',
  swap337: '礦池賬戶',
  swap338: '錢包賬戶',
  swap339: '貢獻值餘額',
  swap340: '消耗貢獻值',
  swap341: '確認劃轉',
  swap342: '增加貢獻值',
  swap343: '轉入成功',
  swap344: '貢獻值不足',
  swap345: '轉出成功',
  swap346: '當前暫無可用餘額',
  swap347: '已超過最大持有',
  swap348: '即將開放',
  swap349: '需支付',
  swap350: '将得到',
  swap351: '邀請獎勵計劃',
  swap352: '邀請用戶共同助力Nebula基礎設施建設，成為Nebula共同建設者，即可獲得多重收益。',
  swap353: '我的邀請鏈接',
  swap354: '礦機列表',
  swap355: '持有列表',
  swap356: '持有數量',
  swap357: '總產出',
  swap358: '今日產出',
  swap359: '產出進度',
  swap360: '礦機',
  swap361: '預計產出',
  swap362: '充值數量',
  swap363: '對方賬戶',
  swap364: '請輸入對方賬戶',
  swap365: '轉賬數量',
  swap366: '轉賬說明',
  swap367: '內部互轉不走區塊，不扣手續費，即時到賬，不可逆請仔細核對對方賬戶。 ',
  swap368: '需要轉到其他平台請通過提幣方式',
  swap369: '超過可成交數',
  swap370: '盲盒',
  swap371: '我的資產',
  swap372: '帳單清單',
  swap373: '請綁定邀請人',
  swap374: '發單總價需大於30VT',
  swap375: '超出了錢包餘額',
  swap376: '入帳中，請稍後查看',
  swap377: '新用戶優惠',
  swap378: '----首次注册即可獲贈價值10 VT HM',
  swap379: '掛單',
  swap380: '錢包地址',
  swap381: '挖礦',
  swap382: '買單',
  swap383: '賣單',
  swap384: '購買價格',
  swap385: '購買時間',
  swap386: '用戶',
  swap387: '發佈時間',
  swap388: '賣出',
  swap389: '買入',
  swap390: '最新成交價',
  swap391: '發布買單',
  swap392: '發布賣單',
  swap393: '敬請期待',
  swap394: '今日收入',
  swap395: '累計收益',
  swap396: '凍結餘額',
  swap397: '應用',
  swap398: '充幣',
  swap399: '資金記錄',
  swap400: '幫助中心',
  swap401: '空投',
  swap402: '支付',
  swap403: '類型',
  swap404: '公告',
  swap405: '暫無公告',
  swap406: '今日價格',
  swap407: '今日收益',
  swap408: '領取星球收益',
  swap409: '領取分享收益',
  swap410: '金星',
  swap411: '土星',
  swap412: '水星',
  swap413: '木星',
  swap414: '火星',
  swap415: '當前不可領取靜態收益',
  swap416: '暫無收益領取',
  swap417: '領取成功',
  swap418: '當前不可領取推薦獎勵',
  swap419: '訂單記錄',
  swap420: '已發佈',
  swap421: '已成交',
  swap422: '已取消',
  swap423: '暫無訂單',
  swap424: '單',
  swap425: '總量',
  swap426: '總價',
  swap427: '已完成數量',
  swap428: '可撤銷數量',
  swap429: '確定',
  swap430: '說明：交易VRT收取稅收手續費， 買入VRT收取{buyFee}%稅收， 賣出VRT收取{sellFee}%稅收',
  swap431: '當前剩餘可交易數量',
  swap432: '個人賬戶數量餘額',
  swap433: '可得',
  swap434: '用戶反饋',
  swap435: '新增圖片（最多三張）',
  swap436: '反饋',
  swap437: '請輸入留言',
  swap438: '請上傳圖片',
  swap439: '請輸入反饋內容',
  swap440: '線上客服',
  swap441: '暫無答覆',
  swap442: '反饋清單',
  swap443: '暫無反饋',
  swap444: '當前等級',
  swap445: '星球使用者',
  swap446: '下一等級',
  swap447: '好友推薦計劃',
  swap448: '綁定關係',
  swap449: '邀請好友加入Venus，一起領取豐厚獎勵，邀請朋友參與星球共識，您將獲得更多收益',
  swap450: '推薦連結',
  swap451: '複製連結',
  swap452: '分享人數',
  swap453: '我的戰隊',
  swap454: '我的業績',
  swap455: '等級',
  swap456: '總業績',
  swap457: '業績',
  swap458: '直推',
  swap459: '我的團隊',
  swap460: '輸入位址',
  swap461: '暫無邀請人',
  swap462: '團隊',
  swap463: '輸入地址綁定關係',
  swap464: '請輸入邀請人位址',
  swap465: '屬性',
  swap466: '幸運',
  swap467: '努力',
  swap468: '非凡',
  swap469: '成就',
  swap470: '霸業',
  swap471: '價值',
  swap472: '產能',
  swap473: '點擊購買',
  swap474: '導入現有流動性池',
  swap475: '運轉中',
  swap476: '已耗盡',
  swap477: '星球產出',
  swap478: '推薦獎勵',
  swap479: '社區收益',
  swap480: '星球站點',
  swap481: '認購時間',
  swap482: '總價值',
  swap483: '已產值',
  swap484: '挖礦進度',
  swap485: '支付成功',
  swap486: '免費空投',
  swap487: '共享價值',
  swap488: '貢獻空投',
  swap489: '已空投',
  swap490: '可領取',
  swap491: '領取',
  swap492: '領取記錄',
  swap493: '時間',
  swap494: '個人',
  swap495: '獲取進度',
  swap496: '邀請',
  swap497: '星球',
  swap498: '幸運轉盤',
  swap499: '市場公告',
  swap500: '問題反饋',
  swap501: '了解',
  swap502: '社區治理',
  swap503: '複製',
  swap504:'星球待釋放',
  swap505:'分享待釋放',
  swap506:'總待釋放',
  swap507:'星球已釋放',
  swap508:'分享已釋放',
  swap509:'總釋放',
  swap510:'收益明細',
  swap511:'來源類型',
  swap512:'獎勵數量',
  swap513:'推薦賬單',
  swap514:'完成時間',
  swap515:'應付',
  swap516:"質押中",
  swap517:"節點",
  swap518:"招募類型",
  swap519:"DAO節點",
  swap520:"升級條件",
  swap521:"帳戶質押20萬枚VRT",
  swap522:"我要升級",
  swap523:"升級成功",
  swap524:"DAO節點招募",
  swap525:"付款",
  swap526:"餘額",
  swap527:"確定付款",
    swap528:"升級中",
    swap529: "DAO 節點招募",
  swap530: "累計已參與",
  swap531: "目前已激勵",
  swap532: "選擇節點類型",
  swap533: "需要支付",
  swap534: "帳戶餘額",
  swap535: "我要升級",
  swap536: "升級紀錄",
  swap537: "激勵紀錄",
  swap538: "沒有更多了",
  swap539: "時間",
  swap540: "節點類型",
  swap541: "扣款金額",
  swap542: "超級節點",
  swap543: "普通節點",
  swap544: "小型節點",
  swap545: "激勵數量",

    "swap546": "提現記錄",
  "swap547": "沒有更多了",
  "swap548": "待提現",
  "swap549": "待審核",
  "swap550": "已駁回",
  "swap551": "待提取",
  "swap552": "待確認",
  "swap553": "已提取",
  "swap554": "長期未確認",
  "swap555": "合約提現失敗",

  swap556: "到交易所地址",
  swap557: "到錢包地址",
  swap558: "輸入交易地址",
  swap559: "時間",
  swap560: "數量",
  swap561: "地址",
  swap562: "狀態",
  swap563: "已駁回",
  swap564: "審核中",
  swap565: "成功",
  swap566: "未知狀態 {status}",
  swap567: "審核成功",
  swap568: "請輸入正確的提幣數量",
  swap569: "請輸入交易地址",
};
